import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export default function Seo({ page }) {
  const { t, lang } = useLang();
  const { pathname } = useLocation();
  const meta = t(`seo.${page}`);
  if (!meta || typeof meta === "string") return null;
  const clean = pathname.replace(/^\/en/, "") || "/";
  const grUrl = `https://digital-company.gr${clean}`;
  const enUrl = `https://digital-company.gr/en${clean === "/" ? "" : clean}`;
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.desc} />
      <link rel="canonical" href={grUrl} />
      <link rel="alternate" hrefLang="el" href={grUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={grUrl} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.desc} />
      <meta property="og:url" content={lang === "en" ? enUrl : grUrl} />
      <meta property="og:locale" content={lang === "en" ? "en_US" : "el_GR"} />
    </Helmet>
  );
}
